import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const RecotizacionesTable = ({
  recotizaciones,
  loading,
  actionBodyTemplate,
  handleRowClick,
}) => {
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [filters, setFilters] = useState(null);
  useEffect(() => {
    initFilters();
  }, []);
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      nombre_producto: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
    });
    setGlobalFilterValue("");
  };
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const renderHeader = () => {
    return (
      <>
      
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2">
          <span className="p-input-icon-left" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
            <i className="pi pi-search" />
            <InputText
              value={globalFilterValue ? globalFilterValue.toUpperCase() : ""}
              onChange={(e) => onGlobalFilterChange(e)}
              placeholder="Buscar por Cliente o Producto..." 
            />
          </span>
          <h6 className="p-input-icon-left ml-2" style={{display: "flex", alignItems: "center", justifyContent: "flex-end"}}>
            {recotizaciones?.length} Recotizaciones
          </h6>
        </div>
      </>
    );
  };
  const header = renderHeader();
  return (
    <div className="col-12">
      <DataTable
        value={recotizaciones?.map((r) => ({
          ...r,
          _productosText: (r.arriendos || []).join(", "),
          _searchableText: [r.cliente?.razonSocial, ...(r.arriendos || [])].join(" ").toUpperCase(),
        }))}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 20, 50, 100]}
        dataKey="id"
        filters={filters}
        filterDisplay="menu"
        loading={loading}
        emptyMessage="No se encontraron Recotizaciones."
        rowClassName="row-clickable"
        className="p-datatable-gridlines "
        onRowClick={(e) => !loading && handleRowClick(e.data)}
        header={header}
        globalFilterFields={["cliente.razonSocial", "_searchableText"]}
        stripedRows="true"
        showGridlines
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Recotizaciones"
        scrollHeight="57vh"
        scrollable
        reorderableColumns
        resizableColumns
        columnResizeMode="fit"
      >
        <Column
          field="id"
          header="Recotización"
          style={{ minWidth: "7rem" }}
          body={(rowData) => (
            <span>
              {rowData.folio ? (
                <><strong>Folio</strong> {rowData.folio} <br/>
                <strong>ID</strong> {rowData.id}</>
              ) : (
                <><strong>ID</strong> {rowData.id}</>
              )}
            </span>
          )}
          sortable 
          sortField="id"
        />

        <Column
          field="cliente.razonSocial"
          header="Cliente"
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.cliente.alias}
          sortable
        />

        <Column
          field="desde"
          header="Desde"
          body={(rowData) => rowData.desde || "No tiene fecha"}
        /> 

        <Column
          field="hasta"
          header="Hasta"
          body={(rowData) => rowData.hasta || "No tiene fecha"}
        />
        <Column
          field="_productosText"
          header="Productos"
          style={{ width: "18%" }}
          body={(rowData) => rowData._productosText || "-"}
          sortable
        />
        <Column
          field="estado"
          header="Estado"
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.estado || "Sin estado"}
          sortField="estado"
        />
        <Column
          field="empresa"
          header="Empresa"
          filterMenuStyle={{ width: "14rem" }}
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.empresa}
          sortable
          sortField="empresa"
        />
        
        <Column
          field="creadorNombre"
          header="Responsable"
          style={{ minWidth: "7rem" }}
          body={(rowData) => rowData.creadorNombre}
          sortable
          sortField="creadorNombre"
        />

        <Column
          header="Acción"
          body={actionBodyTemplate}
          style={{ minWidth: "12rem", textAlign: "center" }}
        /> 
      </DataTable>

    </div>
  );
};

export default RecotizacionesTable;
